import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AdicionaisEDescontosRoutingModule } from './adicionais-e-descontos-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    AdicionaisEDescontosRoutingModule
  ]
})
export class AdicionaisEDescontosModule { }
